define('viewmodels/AMLRiskAssessment/AMLControlRiskAssessment',['services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'viewmodels/Weightings_Thresholds/ControlThresholds', 'viewmodels/Weightings_Thresholds/ControlsWeightings', 'services/utils', 'viewmodels/GeneralSettings'],
    function (appsecurity, navigation, app, logger, system, ControlsThresholds, ControlWeightings, utils, ObjGeneralSettings) {
        AMLViewModel = {
            activate: activate,
            attached: attached,
            detached: detached,
            appsecurity: appsecurity,
            utils: utils,
            ControlsThresholds: ControlsThresholds,
            ControlWeightings: ControlWeightings,
            DownloadControlsReport: DownloadControlsReport,
            openWeightings: openWeightings,
            openControlsThresholds: openControlsThresholds,
            ObjGeneralSettings: ObjGeneralSettings,
            openSideNav: openSideNav,
            closeSideNav: closeSideNav,
            ApplyBuFitlers: ApplyBuFitlers,
            ClearOrgFilterSelection: ClearOrgFilterSelection,
            ClearBUFilterSelection: ClearBUFilterSelection,
            CollapseAllTreeView: CollapseAllTreeView,
            ExpandAllTreeView: ExpandAllTreeView,
            SearchTreeView: SearchTreeView,
            showControlResponseCommentsPopUp: showControlResponseCommentsPopUp,
            ShowComments: ShowComments,
            ClearResult: ClearResult,
            ResetSearch: ResetSearch,
            SearchResult: SearchResult,
            expandCntrlLw: expandCntrlLw,
            expandFactCntl: expandFactCntl,
            //ko-observables starts here
            BUTitle: ko.observable('Business Unit'),
            ScreenName: ko.observable(),
            LocaleCheckFlag: ko.observable(false),
            AssessmentTypeId: ko.observable(),
            OverrideCommentsList: ko.observableArray([]),
            IsSideNavOpen: ko.observable(0),
            OrgLvlDrpDwnList: ko.observableArray(),
            OrgLvlValueList: ko.observableArray(),
            SubCheckboxSelected: SubCheckboxSelected,
            AssessmentType: ko.observable(''),
            ControlResponseCommentsList: ko.observableArray([]),
            ClickedControlAreaId: ko.observable(),
            ClickedControlAreaName: ko.observable(),
            BusinessUnitListFilter: ko.observableArray([]),
            BusinessUnitListForFilters: ko.observableArray([]),
            BusinessUnitListForFiltersDUP: ko.observableArray([]),
            SelectedCheckedList: ko.observableArray([]),
            SelectedCheckedBUList: ko.observableArray([]),
            ClearAllBuFitlers: ClearAllBuFitlers,
            BUFiltersApplied: ko.observable(false),
            FiltersListFlag: ko.observable(false),
            FinalOrgFilterList: ko.observableArray([]),
            DistinctFileredBUs: ko.observableArray([]),
            NumberOfBUsSelectedRA: ko.observable(0),
            hasSubArea: ko.observable(),
            SurveyCategoryList: ko.observableArray([]),
            SurveyCategoryTabClick: SurveyCategoryTabClick,
            SelectedSurveyComponentId: ko.observable(),
            ClickedControlAreaParentId: ko.observable(),
            ClickedControlAreaParentName: ko.observable(),
            SelectedBUIds: ko.observable(),
            ControlQuestionsFlag: ko.observable(true),
            ControlAreasFlag: ko.observable(true),
            AreaType: ko.observable(),
            BusinessUnitListCount: ko.observableArray([]),
            editableResponseTypeCount: ko.observableArray([]),
            TotalSubFactorDataList: ko.observableArray([]),
            SubFactorGridDataList: ko.observableArray([]),
            ColspanValue: ko.observable(2),
            ColspanValueMin: ko.observable(1),
            DataTableColumnWidth: ko.observable(''),
            CalculatedBottomLevelsQual: ko.observableArray([]),
            ShowBottomLevelsFlag: ko.observable(false),
            jsonResultControls: ko.observableArray([]),
            SubFactorGridDataListDUP: ko.observableArray([]),
            BreadCrumbArray: ko.observable(''),
            AreaLeveljstree: ko.observableArray([]),
            SurveyTypeClicked: ko.observable(),
            hasChildNodes: ko.observable(false),
            NavigationMenuHideShow: NavigationMenuHideShow,
            WTBusinessUnits: ko.observableArray([]),
            AreasOrQuestions: ko.observableArray([]),
            ControlsWeight: ko.observableArray([]),
            decimalLimit: ko.observable(),
            totalValidityFlag: ko.observable(1),
            QualThresholdValuesList: ko.observableArray([]),
            Query: ko.observable(),
            Cntrlstate: ko.observable(false),
            ShowOverallCntrlLw: ko.observable(false),
            FactCntlState: ko.observable(true),
            ShowFactCntlLw: ko.observable(true),
        };
        return AMLViewModel;

        //#region Page Load Methods

        function activate() {
            try {
                var Id = AMLViewModel.appsecurity.getParameterByName('atype');
                AMLViewModel.AssessmentTypeId(Id);
                AMLViewModel.appsecurity.GetAssessmentNames().then(function () {

                    AMLViewModel.AssessmentType(AMLViewModel.appsecurity.GetAssessmentName(AMLViewModel.AssessmentTypeId()))
                    AMLViewModel.ScreenName(AMLViewModel.AssessmentType() + ' ' + ((!AMLViewModel.LocaleCheckFlag() || AMLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ControlsAssessmentHeading') == -1) ? 'Controls Assessment' : AMLViewModel.ObjGeneralSettings.LocalizedTextList()[AMLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ControlsAssessmentHeading')].Name()));
                });
                AMLViewModel.BreadCrumbArray('');

                if (AMLViewModel.ObjGeneralSettings === undefined || AMLViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((AMLViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || AMLViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && AMLViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                    AMLViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {

                        if (AMLViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AMLViewModel.ObjGeneralSettings.LocalizedTextList() == null || AMLViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AMLViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AMLViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            AMLViewModel.LocaleCheckFlag(false);
                        else
                            AMLViewModel.LocaleCheckFlag(true);
                    });
                }
                else {
                    if (AMLViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AMLViewModel.ObjGeneralSettings.LocalizedTextList() == null || AMLViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AMLViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AMLViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        AMLViewModel.LocaleCheckFlag(false);
                    else
                        AMLViewModel.LocaleCheckFlag(true);
                }
                AMLViewModel.BUTitle((AMLViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AMLViewModel.ObjGeneralSettings.LocalizedTextList() == null || AMLViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AMLViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AMLViewModel.ObjGeneralSettings.LocalizedIndexList() == null || AMLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits') == -1) ? 'Business Unit' : AMLViewModel.ObjGeneralSettings.LocalizedTextList()[AMLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('BusinessUnits')].Name());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                AMLViewModel.BusinessUnitListFilter([]);
                $($(document.getElementsByClassName('list-group-item')).get(0)).addClass('active');
                $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(0)).addClass('active');
                $('#loadingMainData').show();
                $("#divNavSwitchHideControls").hide();
                GetSurveyCategoryTabs();

                AMLViewModel.SelectedCheckedBUList([]);
                AMLViewModel.SelectedCheckedList([]);
                closeSideNav();
                AMLViewModel.BUFiltersApplied(false);
                AMLViewModel.FiltersListFlag(false);
                AMLViewModel.NumberOfBUsSelectedRA(0);
                $('.badge').css({ 'display': 'none' });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
                $($(document.getElementsByClassName('list-group-item')).get(0)).removeClass('active');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Report Excels

        function DownloadControlsReport() {
            try {
                var ConcatBUList = "";
                if (AMLViewModel.BusinessUnitListForFilters() != undefined && AMLViewModel.BusinessUnitListForFilters().length > 0) {
                    for (var i = 0; i < AMLViewModel.BusinessUnitListForFilters().length; i++) {
                        if (i == 0)
                            ConcatBUList += AMLViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                        else {
                            ConcatBUList += "," + AMLViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                        }
                    }

                }
                var ClickedAreaId = AMLViewModel.ClickedControlAreaId();
                var ClickedAreaName = AMLViewModel.ClickedControlAreaName();
                if (AMLViewModel.hasSubArea() === false) {
                    ClickedAreaId = AMLViewModel.ClickedControlAreaParentId();
                    ClickedAreaName = AMLViewModel.ClickedControlAreaParentName();
                }
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), Assessment_type: AMLViewModel.AssessmentTypeId(), AreaId: ClickedAreaId, ZAT_UID: AMLViewModel.SelectedSurveyComponentId(), TYPE: AMLViewModel.AreaType(), AreaName: ClickedAreaName, BUListString: ConcatBUList
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadControlsOverallReport", payLoad, '_blank');
            }
            catch (e) {
                var msg = 'Exception' + e + 'source: DownloadControlsReport() in AmlControlRiskAssessment.js';
                logger.logMessage(e);
            }
        }

        //#endregion

        //#region Controls RA Methods

        function GetSurveyCategoryTabs() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetControlsSurveyCategoryTabs",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { "AssessmentId": AMLViewModel.AssessmentTypeId(), "ScreenType": "RA" }
                })
                    .success(function (jsonResult, success) {
                        try {
                            if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description == null) {
                                var mappedTabList = $.map(jsonResult, function (result) {
                                    return new SurveyCategoryModel(result);
                                });
                                AMLViewModel.SurveyCategoryList(mappedTabList);
                                $('#SurveyCategoryTab').tabs();
                                $('#SurveyCategoryTab').tabs('refresh');
                                $('#SurveyCategoryTab').tabs({ active: 0 });
                                $($('#SurveyCategoryTab li').get(0)).trigger('click');
                                scrollableTabs();
                            }
                            else {
                                if (jsonResult == null || jsonResult == undefined || jsonResult.length == 0) {
                                }
                                else {
                                    var msg = 'An error occurred. Please contact your Application Administrator.';
                                    logger.logError(jsonResult[jsonResult.length - 1].Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLViewModel), true);
                                }
                            }
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() Success method in AMLThresholds.js';
                            logger.logMessage(msg);
                        }

                    })
                    .fail(function (error, status) {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option == "OK")
                                        navigation.unauthorized();
                                })
                        }
                        else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyCategoryTabs() method in AMLThresholds.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyCategoryTabs() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        function SurveyCategoryTabClick(data, event) {
            try {
                $('.SurveyCategoryTabClass').removeClass("active");
                $('#SurveyCategoryTab_' + data.SurveyCategoryId()).addClass("active");
                $('#ControlsGridLayout').hide();
                NavigationMenuHideShow('Show');
                AMLViewModel.SelectedSurveyComponentId(data.SurveyCategoryId());
                AMLViewModel.SurveyTypeClicked(data.SurveyGroupShortName());
                InitiateLevelTree();
                $("#spanExpandAll").text((!AMLViewModel.LocaleCheckFlag() || AMLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : AMLViewModel.ObjGeneralSettings.LocalizedTextList()[AMLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name());
                $("#arrowSpan").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryTabClick() method in AMLThresholds.js';
                logger.logMessage(msg);
            }
        }

        function GetAllControlsData() {
            try {
                $("#ControlsAreaGrid").hide();
                $("#ControlsOverallGrid").hide();
                if (AMLViewModel.Query() != "")
                    AMLViewModel.Query('');
                var businessUnitIds = "";
                AMLViewModel.SelectedBUIds('');
                if (AMLViewModel.BUFiltersApplied() == true) {
                    if (AMLViewModel.BusinessUnitListForFilters() != undefined && AMLViewModel.BusinessUnitListForFilters().length > 0) {
                        for (var i = 0; i < AMLViewModel.BusinessUnitListForFilters().length; i++) {
                            if (i == 0)
                                businessUnitIds = AMLViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                            else
                                businessUnitIds = businessUnitIds + ',' + AMLViewModel.BusinessUnitListForFilters()[i].BusinessUnitId();
                        }
                        AMLViewModel.SelectedBUIds(businessUnitIds);
                    }
                }
                $.ajax({
                    url: "/api/AMLControlRiskAssessment/GetAllControlsRAData",
                    type: "GET",
                    data: {
                        "AreaId": AMLViewModel.ClickedControlAreaId(), "AssessmentTypeId": AMLViewModel.AssessmentTypeId(),
                        "SurveyCategoryID": AMLViewModel.SelectedSurveyComponentId(), "TableType": AMLViewModel.AreaType(),
                        "BusinessUnitIds": AMLViewModel.SelectedBUIds()
                    },
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllControlsData() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult.Incident_Description == null) {

                        AMLViewModel.jsonResultControls([]);
                        AMLViewModel.jsonResultControls(jsonResult);

                        if (jsonResult.BusinessUnitList.length > 0) {
                            AMLViewModel.BreadCrumbArray('');
                            AMLViewModel.BreadCrumbArray(jsonResult.breadCrumbList);
                            AMLViewModel.editableResponseTypeCount([]);
                            AMLViewModel.BusinessUnitListCount([]);
                            $('#NoBussinessUnitserror').hide();
                            var mappedBuList = $.map(jsonResult.BusinessUnitList, function (result) {
                                return new BusinessUnitModel(result);
                            });
                            AMLViewModel.BusinessUnitListCount(mappedBuList);
                            AMLViewModel.NumberOfBUsSelectedRA(mappedBuList.length);

                            if (jsonResult.EditableResponseTypes.length > 0) {
                                AMLViewModel.editableResponseTypeCount([]);
                                var mappedresponseColumnList = $.map(jsonResult.EditableResponseTypes, function (result) {
                                    return new ResponselevelModel(result);
                                });
                                AMLViewModel.editableResponseTypeCount(mappedresponseColumnList);
                                AMLViewModel.ColspanValue(mappedresponseColumnList.length);
                                AMLViewModel.ColspanValueMin(mappedresponseColumnList.length - 1);
                            }
                        }
                        AMLViewModel.SubFactorGridDataList([]);
                        AMLViewModel.SubFactorGridDataListDUP([]);
                        if (AMLViewModel.ControlQuestionsFlag() == true) {
                            if (jsonResult.RiskSubFactorDataList.length > 0) {
                                var MappedObject = $.map(jsonResult.RiskSubFactorDataList, function (result) {
                                    return new SubFactorDataListModel(result);
                                });
                                AMLViewModel.SubFactorGridDataList(MappedObject);
                                AMLViewModel.SubFactorGridDataListDUP(MappedObject);
                            }
                        }

                        if (jsonResult.TotalSubFactorDataList.length > 0) {
                            AMLViewModel.TotalSubFactorDataList([]);
                            var MappedObject = $.map(jsonResult.TotalSubFactorDataList, function (result) {
                                return new SubFactorDataModel(result);
                            });
                            AMLViewModel.TotalSubFactorDataList(MappedObject);
                        }

                        if (AMLViewModel.AreaType() === 'A') {

                            if (jsonResult.CalculatedBottomLevels.length > 0) {
                                AMLViewModel.CalculatedBottomLevelsQual([]);
                                var MappedObject = $.map(jsonResult.CalculatedBottomLevels, function (result) {
                                    return new CalculatedBottomLevelModel(result);
                                });
                                AMLViewModel.CalculatedBottomLevelsQual(MappedObject);
                            }
                            AMLViewModel.ShowBottomLevelsFlag(jsonResult.FlagToHideRows);
                            $('#ControlsAreaGrid').show();

                            $('#tblRAControl tbody').scroll(function (e) { //detect a scroll event on the tbody
                                $('#tblRAControl thead').css("left", -$("#tblRAControl tbody").scrollLeft()); //fix the thead relative to the body scrolling
                                $('#tblRAControl thead th:nth-child(1)').css("left", $("#tblRAControl tbody").scrollLeft()); //fix the first cell of the header
                                $('#tblRAControl tbody td:nth-child(1)').css("left", $("#tblRAControl tbody").scrollLeft()); //fix the first column of tdbody
                            });

                        } else if (AMLViewModel.AreaType() === 'O') {
                            $('#ControlsOverallGrid').show();
                            $('#tblRAControlOverall tbody').scroll(function (e) { //detect a scroll event on the tbody
                                $('#tblRAControlOverall thead').css("left", -$("#tblRAControlOverall tbody").scrollLeft()); //fix the thead relative to the body scrolling
                                $('#tblRAControlOverall thead th:nth-child(1)').css("left", $("#tblRAControlOverall tbody").scrollLeft()); //fix the first cell of the header
                                $('#tblRAControlOverall tbody td:nth-child(1)').css("left", $("#tblRAControlOverall tbody").scrollLeft()); //fix the first column of tdbody
                            });
                            if (AMLViewModel.Query() != "") {
                                SearchResult();
                            } else {
                                for (var i = 0; i < AMLViewModel.SubFactorGridDataList().length; i++) {
                                    $(".raTaxo_" + AMLViewModel.SubFactorGridDataList()[i].SubFactorId()).show();
                                }
                            }
                        }
                    }
                    else {
                        if (jsonResult == null || jsonResult == undefined) {
                            $('#ControlsGridLayout').hide();
                            $('#NoFacError').show();
                        }
                        else {
                            $('#ControlsGridLayout').hide();
                            $('#NoFacError').show();
                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(jsonResult.Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllControlsData() method in AMLControlRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllControlsData() method in AMLControlRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllControlsData() method in AMLControlRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        //#endregion

        //#region Expand-Collapse Methods

        function expandCntrlLw() {
            if (AMLViewModel.Cntrlstate() == false) {
                //expand
                AMLViewModel.ShowOverallCntrlLw(true);
                AMLViewModel.Cntrlstate(true);
                $("#spanInhContlw").addClass("fa-caret-down").removeClass("fa-caret-right");
            }
            else {
                //collapse
                AMLViewModel.ShowOverallCntrlLw(false);
                AMLViewModel.Cntrlstate(false);
                $("#spanInhContlw").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
        }

        function expandFactCntl() {
            if (AMLViewModel.FactCntlState() == false) {
                //expand
                AMLViewModel.ShowFactCntlLw(true);
                AMLViewModel.FactCntlState(true);
                $("#spanFactCntl").addClass("fa-caret-down").removeClass("fa-caret-right");
                if (AMLViewModel.Query() != "") {
                    SearchResult();
                }
            }
            else {
                //collapse
                AMLViewModel.ShowFactCntlLw(false);
                AMLViewModel.FactCntlState(false);
                $("#spanFactCntl").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
        }

        //#endregion

        //#region Comments PopUp Methods

        function showControlResponseCommentsPopUp(data, event) {
            try {
                $('#ControlResponseCommentsPopUp').modal('show');
                $('#ControlCommentsMain').hide();
                GetControlResponseComments(data);
            }
            catch (e) {
                var msg = 'Exception' + e + 'Source showQualCommentsPopUp() in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ShowComments(businessUnitId) {
            try {
                $('#OverrideCommentsPopUp').modal('show');
                $('#CommentsMain').hide();
                GetOverrideComments(businessUnitId);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowComments() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function GetControlResponseComments(data) {
            try {

                $.ajax({
                    url: "/api/AMLRiskAssessment/GetResponseComments",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        "BusinessUnitId": data.Response_BUId(), "RiskFactorId": data.SubFactorId(), "ResponseTypeId": data.ResponseId(),
                        "AssessmentTypeId": AMLViewModel.AssessmentTypeId(), "ZATId": AMLViewModel.SelectedSurveyComponentId()
                    }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetControlResponseComments() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    $('#ControlCommentsMain').show();
                    AMLViewModel.ControlResponseCommentsList([]);
                    if (jsonResult == null || jsonResult == undefined) {
                        logger.logError('Failed to load Qualitatively Adjusted Rating comments. Please try again.', 'Error', system.getModuleId(AMLViewModel), true);
                    }
                    else {
                        if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description == null) {
                            var mappedControlResponseCommentsList = $.map(jsonResult, function (result) {
                                return new ResponseCommentsModel(result);
                            })
                            AMLViewModel.ControlResponseCommentsList(mappedControlResponseCommentsList);
                            $('#ControlResponseComments')[0].scrollTop = $('#ControlResponseComments')[0].scrollHeight;
                        }
                        else if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description != null) {
                            var msg = 'Failed to load Qualitatively Adjusted Rating comments. Please try again.';
                            logger.logError(jsonResult[jsonResult.length - 1].Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetControlResponseComments() method in AMLControlRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetControlResponseComments() method in AMLControlRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetControlResponseComments() method in AMLControlRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetOverrideComments(businessUnitId) {
            try {

                var ClickedAreaId = AMLViewModel.ClickedControlAreaId();
                if (AMLViewModel.hasSubArea() === false) {
                    ClickedAreaId = AMLViewModel.ClickedControlAreaParentId();
                }
                $.ajax({
                    url: "/api/AMLRiskAssessment/GetOverrideComment",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        BusinessUnitId: businessUnitId, RiskAreaId: parseInt(ClickedAreaId), RiskFactorId: null,
                        CommentType: AMLViewModel.AreaType(), AssessmentType: AMLViewModel.AssessmentTypeId(), RiskAreaType: "CTRL",
                        ZATId: AMLViewModel.SelectedSurveyComponentId()
                    }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetOverrideComments() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    $('#CommentsMain').show();
                    AMLViewModel.OverrideCommentsList([]);
                    if (jsonResult == null || jsonResult == undefined) {
                        logger.logError('Failed to load Qualitatively Adjusted Rating comments. Please try again.', 'Error', system.getModuleId(AMLViewModel), true);
                    }
                    else {
                        if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description == null) {
                            var mappedOverrideCommentsList = $.map(jsonResult, function (result) {
                                return new OverrideCommentModel(result);
                            })
                            AMLViewModel.OverrideCommentsList(mappedOverrideCommentsList);
                            $('#ResponseComments')[0].scrollTop = $('#ResponseComments')[0].scrollHeight;
                        }
                        else if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description != null) {
                            var msg = 'Failed to load Qualitatively Adjusted Rating comments. Please try again.';
                            logger.logError(jsonResult[jsonResult.length - 1].Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess call in GetOverrideComments() method in AMLControlRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetOverrideComments() method in AMLControlRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetOverrideComments() method in AMLControlRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        //#endregion

        //#region Thresholds-Weightings Popup Methods

        function openControlsThresholds() {
            try {
                $('#ThresholdsPopUpControl').modal('show');
                $('#FactorDataDivTh').hide();
                GetQualThresholdData();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: openControlsThresholds() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function GetQualThresholdData() {
            try {
                $.ajax({
                    url: "/api/WeightingsThresholds/GetQualFactorThreshold",
                    data: {
                        "TableId": AMLViewModel.ClickedControlAreaId(), "AssessmentType": AMLViewModel.AssessmentTypeId(), "TableType": "A", "SurveyCategoryId": AMLViewModel.SelectedSurveyComponentId()
                    },
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetQualThresholdData() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description == null) {
                        $('#NoDataErrorThresholds').hide();
                        $("#error").hide();
                        $('#FactorDataDivTh').show();

                        var MappedQualThresholdValue = $.map(jsonResult, function (result) {
                            return new QualThresholdValueModel(result);
                        });
                        $('#tblThreshold tbody tr').remove();
                        AMLViewModel.QualThresholdValuesList(MappedQualThresholdValue);

                    }
                    else {
                        if (jsonResult.length == 0) {
                            $('#FactorDataDivTh').show();

                            $('#NoDataErrorThresholds').show();
                        }
                        else {
                            $('#FactorDataDivTh').show();

                            $('#NoDataErrorThresholds').show();
                            var msg = 'Failed to load Qualitatively Adjusted Rating comments. Please try again.';
                            logger.logError(jsonResult[jsonResult.length - 1].Incident_Description + " - " + msg, 'Error', system.getModuleId(AmlViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQualThresholdData() method in AMLControlRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQualThresholdData() method in AMLControlRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail  in GetQualThresholdData() method in AMLControlRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        function QualThresholdValueModel(item) {
            try {
                var self = this;
                self.Uid = ko.observable(item.Uid);
                self.FinalRiskId = ko.observable(item.FinalRiskId);
                self.Min = ko.observable(item.Min);
                self.Max = ko.observable(item.Max);
                self.ValidationMessage = ko.observable(null);
                self.ShouldShowMessage = ko.observable(false);
                self.ValidationMessageMin = ko.observable(null);
                self.ShouldShowMessageMin = ko.observable(false);
                self.Description = ko.observable($('<div/>').html(item.Description).text());
                self.CSS = ko.observable(item.Css);
                self.Level = ko.observable(item.Level);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QualThresholdValueModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function openWeightings() {
            try {
                $('#WeightingsPopUpControl').modal('show');
                GetControlsWeight();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: openWeightings() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function GetControlsWeight() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/WeightingsThresholds/GetControlsWeights",
                    type: "GET",
                    headers: headers,
                    data: {
                        "AssessmentType": AMLViewModel.AssessmentTypeId(), "SurveyCategoryId": AMLViewModel.SelectedSurveyComponentId().toString(), "AreaId": AMLViewModel.ClickedControlAreaId(), "OrgLevel": 0, "NodeType": AMLViewModel.AreaType()
                    }
                }).success((jsonResult, success) => {
                    try {
                        if (jsonResult.Incident_Description == null) {
                            AMLViewModel.WTBusinessUnits([]);
                            AMLViewModel.AreasOrQuestions([]);
                            AMLViewModel.ControlsWeight([]);
                            AMLViewModel.decimalLimit(jsonResult.precisionObject);

                            if (jsonResult.BUWiseWeightings.length > 0) {
                                var mappedBusinessUnitData = $.map(jsonResult.BUWiseWeightings, (result) => {
                                    return new WTBusinessLevelsModel(result);
                                });
                                AMLViewModel.WTBusinessUnits([]);
                                AMLViewModel.WTBusinessUnits(mappedBusinessUnitData);
                            }

                            AMLViewModel.totalValidityFlag(1);

                            for (var i = 0; i < AMLViewModel.WTBusinessUnits().length; i++) {
                                if (AMLViewModel.WTBusinessUnits()[i].total() == 100.00000 || AMLViewModel.WTBusinessUnits()[i].total() == 0.00000) {
                                    AMLViewModel.totalValidityFlag(1);
                                }
                                else {
                                    AMLViewModel.totalValidityFlag(0);
                                    break;
                                }
                            }

                            AMLViewModel.AreasOrQuestions([]);
                            if (jsonResult.AreaWiseWeightings.length > 0) {
                                var mappedAreasOrQuestions = $.map(jsonResult.AreaWiseWeightings, (result) => {
                                    return new RiskAreaModel(result);
                                });
                                AMLViewModel.AreasOrQuestions([]);
                                AMLViewModel.AreasOrQuestions(mappedAreasOrQuestions);
                            }

                            AMLViewModel.ControlsWeight([]);
                            if (jsonResult.WeightingsList.length > 0) {
                                var mappedControlsWeight = $.map(jsonResult.WeightingsList, (result) => {
                                    return new WeightingsModel(result);
                                });
                                AMLViewModel.ControlsWeight([]);
                                AMLViewModel.ControlsWeight(mappedControlsWeight);
                            }

                            $('#WeightingsTableRA tbody').scroll(function (e) { //detect a scroll event on the tbody
                                $('#WeightingsTableRA thead').css("left", -$("#WeightingsTableRA tbody").scrollLeft()); //fix the thead relative to the body scrolling
                                $('#WeightingsTableRA thead th:nth-child(1)').css("left", $("#WeightingsTableRA tbody").scrollLeft()); //fix the first cell of the header
                                $('#WeightingsTableRA tbody td:nth-child(1)').css("left", $("#WeightingsTableRA tbody").scrollLeft()); //fix the first column of tdbody
                            });
                        }
                        else {
                            if (jsonResult == null || jsonResult == undefined) {
                                logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AMLViewModel), true);
                            }
                            else {
                                var msg = 'An error occurred. Please contact your Application Administrator.';
                                logger.logError(jsonResult.Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLViewModel), true);
                            }
                        }
                    }
                    catch (e) {
                        let msg = 'Exception: ' + e + ' | Source: GetControlsWeight() ajaxSuccess method in AMLControlRiskAssessment.js';
                        logger.logMessage(msg);
                    }

                })
                    .fail((error, status) => {
                        if (error.status === 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then((option) => {
                                    if (option === "OK")
                                        navigation.unauthorized();
                                });
                        }
                        else {
                            let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetControlsWeight() method in AMLControlRiskAssessment.js';
                            logger.logMessage(msg);
                        }

                    });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: GetControlsWeight() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Filter Methods

        function openSideNav() {
            try {
                if ($('#BusinessUnitFilterBtn').hasClass("openFilter")) {
                    closeSideNav();
                } else {
                    $('#BusinessUnitFilterBtn').addClass("openFilter");
                    $('#OrgFilterError').hide();
                    $('#BUFilterError').hide();
                    $('#OrganizationalLevel').show();
                    $('#BuselectFilter').show();
                    $('#FilterButton').show();
                    $('#OrganizationalLevel').show();
                    if (AMLViewModel.FiltersListFlag() == false) {
                        GetAllOrganizationalLevels();
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: openSideNav() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function closeSideNav() {
            try {
                $('#BusinessUnitFilterBtn').removeClass("openFilter");
                $('#OrgFilterError').hide();
                $('#BUFilterError').hide();
                $('#OrganizationalLevel').hide();
                $('#BuselectFilter').hide();
                $('#FilterButton').hide();
                $('#SideNav').hide();
                AMLViewModel.IsSideNavOpen(0);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: closeSideNav() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function GetAllOrganizationalLevels() {
            try {
                return $.ajax({
                    url: "/api/Configuration/getDistinctBusinessLevelsAllBUApplicability",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { TypeId: AMLViewModel.AssessmentTypeId(), YOA: null }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllOrganizationalLevels() in AMLControlRiskAssessment.js';
                logger.logMessage(msg);

            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description == null) {
                        var OrganizationalLevels = $.map(jsonResult, function (result) {
                            return new BusinessLevelsModel(result);
                        });
                        if (OrganizationalLevels.length > 0) {
                            AMLViewModel.OrgLvlDrpDwnList(OrganizationalLevels);
                            AMLViewModel.OrgLvlValueList(AMLViewModel.OrgLvlDrpDwnList()[0].BusinessLevelValueList());
                        }
                        //Get all BU list with org sub level id's
                        GetAllBusinessUnitsForFilters();
                        AMLViewModel.SelectedCheckedList([]);
                        AMLViewModel.SelectedCheckedBUList([]);
                        document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                    }
                    else {
                        if (jsonResult.length == 0 || jsonResult == null) {
                            logger.logError('An error occurred.Please contact your Application Administrator.', 'Error', system.getModuleId(AMLViewModel), true);
                        }
                        else {
                            var msg = 'An error occurred.Please contact your Application Administrator.';
                            logger.logError(jsonResult[jsonResult.length - 1].Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllOrganizationalLevels() in AMLControlRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AMLControlRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllOrganizationalLevels() method in AMLControlRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetAllBusinessUnitsForFilters() {
            try {
                return $.ajax({
                    url: "/api/AMLRiskAssessment/GetAllBusinessUnitsForFiltersBUApplicability",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { TypeId: AMLViewModel.AssessmentTypeId() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllBusinessUnitsForFilters() in AMLControlRiskAssessment.js';
                logger.logMessage(msg);

            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult.length > 0 && jsonResult[jsonResult.length - 1].Incident_Description == null) {
                        var mappedBuList = $.map(jsonResult, function (result) {
                            return new BusinessUnitModelFilter(result);
                        });
                        AMLViewModel.SelectedCheckedBUList([]);
                        AMLViewModel.BusinessUnitListForFilters(mappedBuList);
                        AMLViewModel.BusinessUnitListForFiltersDUP(mappedBuList);
                        BindHTML();
                        $('#OrgFilterError').hide();
                        $('#BUFilterError').hide();
                        AMLViewModel.FiltersListFlag(true);
                    }
                    else {
                        if (jsonResult.length == 0 || jsonResult == null) {
                            logger.logError('An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(AMLViewModel), true);

                        }
                        else {
                            var msg = 'An error occurred. Please contact your Application Administrator.';
                            logger.logError(jsonResult[jsonResult.length - 1].Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLViewModel), true);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllBusinessUnitsForFilters() in AMLControlRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in AMLControlRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllBusinessUnitsForFilters() method in AMLControlRiskAssessment.js';
                    logger.logMessage(msg);
                }
            }
        }

        function BindHTML() {
            try {
                //Org Level Filter Fossil style
                var OrgList = "";
                OrgList += '<div class="filter-nav1"><ul class="nav nav-tabs"><li class="fl-lbl"><span data-bind="html: (!$root.LocaleCheckFlag() || $root.ObjGeneralSettings.LocalizedIndexList.indexOf("AddFilters") == -1 )? "Add Filters": $root.ObjGeneralSettings.LocalizedTextList()[$root.ObjGeneralSettings.LocalizedIndexList.indexOf("AddFilters")].Name"></span> </li>';
                for (var i = 0; i < AMLViewModel.OrgLvlDrpDwnList().length; i++) {
                    if (i == 0) {
                        OrgList += '<li class="active"><a href="#tab_' + AMLViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + AMLViewModel.OrgLvlDrpDwnList()[i].BlName() + ' <i class="fa fa-chevron-down" aria-hidden="true"></i> </a></li>'
                    } else {
                        OrgList += '<li class=""><a href="#tab_' + AMLViewModel.OrgLvlDrpDwnList()[i].BlId() + '" data-toggle="tab">' + AMLViewModel.OrgLvlDrpDwnList()[i].BlName() + ' <i class="fa fa-chevron-down" aria-hidden="true" ></i> </a></li>'
                    }
                }
                OrgList += '<li class=""><a href="#tab_BU" data-toggle="tab">' + AMLViewModel.BUTitle() + ' <i class="fa fa-chevron-down" aria-hidden="true"></i> </a></li>'
                OrgList += '</ul><div class="tab-content filter-content">';
                for (var i = 0; i < AMLViewModel.OrgLvlDrpDwnList().length; i++) {
                    if (i == 0) {
                        OrgList += '<div class="tab-pane active" id="tab_' + AMLViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                    } else {
                        OrgList += '<div class="tab-pane" id="tab_' + AMLViewModel.OrgLvlDrpDwnList()[i].BlId() + '">'
                    }

                    if (AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length > 0) {

                        for (var j = 0; j < AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; j++) {
                            OrgList += '<label  class="ft-selection"><input id=sublevel' + AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;"><i class="fa fa-check ' + AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueId() + '" aria-hidden="true" style="display:none"></i><span class="cc-facet-result-text tag-text">' + AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[j].BlvalueName() + '</span></label>';
                        }

                    }
                    OrgList += '</div>';
                }
                OrgList += '<div class="tab-pane" id="tab_BU">';
                AMLViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                    var seen = [];
                    return AMLViewModel.BusinessUnitListForFilters().filter(function (n) {
                        return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                    });
                });
                AMLViewModel.BusinessUnitListForFilters(AMLViewModel.DistinctFileredBUs());
                for (var w = 0; w < AMLViewModel.BusinessUnitListForFilters().length; w++) {
                    OrgList += '<label class="ft-selection">' +
                        '<input id=sublevelBU' + AMLViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + ' type="checkbox" data-bind="event:{change:$root.SubCheckboxSelected}" style="font-weight: 600;position : fixed;clip : rect(0,0,0,0);pointer-events : none;">' +
                        '<i class="fa fa-check ' + AMLViewModel.BusinessUnitListForFilters()[w].BusinessUnitId() + '" aria-hidden="true" style="display:none"></i>' +
                        '<span class="cc-facet-result-text tag-text">' + AMLViewModel.BusinessUnitListForFilters()[w].BusinessUnitName() + '</span>' +
                        '</label>';
                }
                OrgList += '</div>';

                if (OrgList == "") {
                    OrgList = '<div id="NoorganizationalLevelerror" class="alert-warning"><label class="control-label">Organizational Levels are not configured for this Year of Assessment.</label></div>';

                }
                document.getElementById('OrganizationalLevel').innerHTML = OrgList;
                for (var i = 0; i < AMLViewModel.OrgLvlDrpDwnList().length; i++) {
                    for (var l = 0; l < AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; l++) {
                        ko.applyBindingsToNode($('#sublevel' + AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[l].BlvalueId()), { event: { change: AMLViewModel.SubCheckboxSelected } }, AMLViewModel);
                    }
                }
                for (var k = 0; k < AMLViewModel.BusinessUnitListForFilters().length; k++) {
                    ko.applyBindingsToNode($('#sublevelBU' + AMLViewModel.BusinessUnitListForFilters()[k].BusinessUnitId()), { event: { change: AMLViewModel.SubCheckboxSelected } }, AMLViewModel);
                }
                AMLViewModel.NumberOfBUsSelectedRA(AMLViewModel.BusinessUnitListForFilters().length);
                $('.badge').css({ 'display': 'none' });
                $('#f-filter').css('display', 'none');
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: BindHTML() function in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SubCheckboxSelected(data, event) {
            try {
                $('#OrgFilterError').hide();
                $('#BUFilterError').hide();
                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("el") + 2);
                var BUselected = "";
                if (isNaN(parseInt(selectedSubOrgLevelID)) && AMLViewModel.SelectedCheckedList().length > 0) {
                    $('#BUFilterError').show();
                    return false;
                }
                else if (!isNaN(parseInt(selectedSubOrgLevelID)) && AMLViewModel.SelectedCheckedBUList().length > 0) {
                    $('#OrgFilterError').show();
                    return false;
                }
                else if (!isNaN(parseInt(selectedSubOrgLevelID)) && AMLViewModel.SelectedCheckedBUList().length == 0) {
                    for (var i = 0; i < AMLViewModel.OrgLvlDrpDwnList().length; i++) {
                        var counterCheck = 0;
                        for (var g = 0; g < AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; g++) {
                            if (AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() == selectedSubOrgLevelID) {
                                if (event.currentTarget.checked) {
                                    $("#sublevel" + AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", true);
                                    $('.fa-check.' + AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'inline-block' });

                                    AMLViewModel.SelectedCheckedList.push({
                                        SubLevelId: AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId(),
                                        SubLevelName: AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueName(),
                                        OrgLevelName: AMLViewModel.OrgLvlDrpDwnList()[i].BlName()
                                    });
                                }
                                else {
                                    $("#sublevel" + AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", false);
                                    $('.fa-check.' + AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'none' });
                                    if (AMLViewModel.SelectedCheckedList().length > 0) {
                                        AMLViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId() })
                                    }
                                }
                            }

                            //Mark parent check box as checked if all sub levels are selected
                            if ($("#sublevel" + AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop('checked')) {
                                counterCheck++;
                            }
                            if (counterCheck > 0 && counterCheck == AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                                $("#" + AMLViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", true);
                            }
                            else if (counterCheck > 0 && counterCheck == AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length) {
                                $("#" + AMLViewModel.OrgLvlDrpDwnList()[i].BlId()).prop("checked", false);
                            }
                        }
                    }
                    //Logic to re-set the BU list
                    AMLViewModel.BusinessUnitListForFilters([]);
                    if (AMLViewModel.SelectedCheckedList().length > 0) {
                        var mappedBuList = $.map(AMLViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            for (var m = 0; m < AMLViewModel.SelectedCheckedList().length; m++) {
                                if (result.SubLevelId() == AMLViewModel.SelectedCheckedList()[m].SubLevelId)
                                    return new BusinessUnitModelDUP(result);
                            }
                        });
                        AMLViewModel.BusinessUnitListForFilters(mappedBuList);
                        //Main tain this list to retain the org filters on deselection of applicability filters
                        AMLViewModel.FinalOrgFilterList(mappedBuList);

                    }
                    else {
                        AMLViewModel.BusinessUnitListForFilters([]);
                        var mappedBuList = $.map(AMLViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            return new BusinessUnitModelDUP(result);
                        });
                        AMLViewModel.BusinessUnitListForFilters(mappedBuList);
                        AMLViewModel.FinalOrgFilterList(mappedBuList);
                    }
                    SetFilterSelection();

                } else if (isNaN(parseInt(selectedSubOrgLevelID)) && AMLViewModel.SelectedCheckedList().length == 0) {
                    BUselected = event.currentTarget.id.substr(event.currentTarget.id.indexOf("BU") + 2);

                    for (var i = 0; i < AMLViewModel.BusinessUnitListForFiltersDUP().length; i++) {
                        if (AMLViewModel.BusinessUnitListForFiltersDUP()[i].BusinessUnitId() == BUselected) {
                            if (event.currentTarget.checked) {
                                $("#sublevelBU" + BUselected).prop("checked", true);
                                $('.fa-check.' + BUselected).css({ 'display': 'inline-block' });

                                AMLViewModel.SelectedCheckedBUList.push({
                                    SubLevelId: AMLViewModel.BusinessUnitListForFiltersDUP()[i].BusinessUnitId(),
                                    SubLevelName: AMLViewModel.BusinessUnitListForFiltersDUP()[i].BusinessUnitName()
                                });
                            }
                            else {
                                $("#sublevelBU" + BUselected).prop("checked", false);
                                $('.fa-check.' + BUselected).css({ 'display': 'none' });
                                if (AMLViewModel.SelectedCheckedBUList().length > 0) {
                                    AMLViewModel.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == AMLViewModel.BusinessUnitListForFiltersDUP()[i].BusinessUnitId() })
                                }
                            }
                            break;
                        }
                    }

                    if (AMLViewModel.SelectedCheckedBUList().length > 0) {
                        //Logic to re-set the BU list
                        AMLViewModel.BusinessUnitListForFilters([]);

                        var mappedBuList = $.map(AMLViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            for (var m = 0; m < AMLViewModel.SelectedCheckedBUList().length; m++) {
                                if (result.BusinessUnitId() == AMLViewModel.SelectedCheckedBUList()[m].SubLevelId)
                                    return new BusinessUnitModelDUP(result);
                            }
                        });
                        AMLViewModel.BusinessUnitListForFilters(mappedBuList);
                    }
                    else {
                        AMLViewModel.BusinessUnitListForFilters([]);
                        var mappedBuList = $.map(AMLViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                            return new BusinessUnitModelDUP(result);
                        });
                        AMLViewModel.BusinessUnitListForFilters(mappedBuList);
                        AMLViewModel.FinalOrgFilterList(mappedBuList);
                    }
                    SetBUFilterSelection();
                }
                //Set count of BU's selected
                if (AMLViewModel.BusinessUnitListForFilters().length > 0) {
                    AMLViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return AMLViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    AMLViewModel.BusinessUnitListForFilters(AMLViewModel.DistinctFileredBUs());
                }

                AMLViewModel.NumberOfBUsSelectedRA(AMLViewModel.BusinessUnitListForFilters().length)
            }
            catch (e) {
                var msg = 'Exception' + e + ' || source:  SubCheckboxSelected function in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function BuLevelValueListModel(item) {
            try {
                var self = this;
                self.BlvalueId = ko.observable($('<div/>').html(item.BlvalueId).text());
                self.BlvalueName = ko.observable($('<div/>').html(item.BlvalueName).text());
                self.ParentBuLevel = ko.observable($('<div/>').html(item.ParentBuLevel).text());
                self.BlvalueShortName = ko.observable($('<div/>').html(item.BlvalueShortName).text());
                self.TargetRow = ko.observable(item.TargetRow);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BuLevelValueListModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SetFilterSelection() {
            try {
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                //Mark Org levels filter seletion
                var contentHtml = "";
                for (var k = 0; k < AMLViewModel.SelectedCheckedList().length; k++) {
                    contentHtml += '<div id="DynamicOptedFilters_' + AMLViewModel.SelectedCheckedList()[k].SubLevelId + '" class="fitem"><span class="hetamap-filter"><span class="fnormal">' + AMLViewModel.SelectedCheckedList()[k].OrgLevelName + '</span> : ' + AMLViewModel.SelectedCheckedList()[k].SubLevelName + '<span id="ClearFilterText_' + AMLViewModel.SelectedCheckedList()[k].SubLevelId + '" class="font-weight-bold bg-transparent mb-2" data-bind="click:ClearOrgFilterSelection"><i class="demo-icon icon-cross_special"></i> </span></span></div>';
                }
                document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
                for (var k = 0; k < AMLViewModel.SelectedCheckedList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterText_' + AMLViewModel.SelectedCheckedList()[k].SubLevelId), { click: AMLViewModel.ClearOrgFilterSelection }, AMLViewModel);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetFilterSelection() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ClearOrgFilterSelection(data, event) {
            try {
                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);;
                document.getElementById('DynamicOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";
                $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
                if (AMLViewModel.SelectedCheckedList().length > 0) {
                    AMLViewModel.SelectedCheckedList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID })
                }

                //Logic to re-set the BU list
                AMLViewModel.BusinessUnitListForFilters([]);
                if (AMLViewModel.SelectedCheckedList().length > 0) {
                    var mappedBuList = $.map(AMLViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        for (var m = 0; m < AMLViewModel.SelectedCheckedList().length; m++) {
                            if (result.SubLevelId() == AMLViewModel.SelectedCheckedList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    AMLViewModel.BusinessUnitListForFilters(mappedBuList);
                    //Main tain this list to retain the org filters on deselection of applicability filters
                    AMLViewModel.FinalOrgFilterList(mappedBuList);

                }
                else {
                    AMLViewModel.BusinessUnitListForFilters([]);
                    var mappedBuList = $.map(AMLViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    AMLViewModel.BusinessUnitListForFilters(mappedBuList);
                    AMLViewModel.FinalOrgFilterList(mappedBuList);
                    $('#BUFilterError').hide();
                }
                //Set count of BU's selected
                if (AMLViewModel.BusinessUnitListForFilters().length > 0) {
                    AMLViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return AMLViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    AMLViewModel.BusinessUnitListForFilters(AMLViewModel.DistinctFileredBUs());
                }

                AMLViewModel.NumberOfBUsSelectedRA(AMLViewModel.BusinessUnitListForFilters().length)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearOrgFilterSelection() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SetBUFilterSelection() {
            try {
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                var contentHtml = "";
                for (var k = 0; k < AMLViewModel.SelectedCheckedBUList().length; k++) {
                    contentHtml += '<div id="DynamicBUOptedFilters_' + AMLViewModel.SelectedCheckedBUList()[k].SubLevelId + '" class="fitem"><span class="hetamap-filter"><span class="fnormal">BU </span> : ' + AMLViewModel.SelectedCheckedBUList()[k].SubLevelName + '<span id="ClearFilterTextBU_' + AMLViewModel.SelectedCheckedBUList()[k].SubLevelId + '" class="font-weight-bold bg-transparent mb-2" data-bind="click:ClearBUFilterSelection"><i class="demo-icon icon-cross_special"></i></span></span></div>';
                }
                document.getElementById('DynamicOrgOptedFilters').innerHTML = contentHtml;
                for (var k = 0; k < AMLViewModel.SelectedCheckedBUList().length; k++) {
                    ko.applyBindingsToNode($('#ClearFilterTextBU_' + AMLViewModel.SelectedCheckedBUList()[k].SubLevelId), { click: AMLViewModel.ClearBUFilterSelection }, AMLViewModel);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetBUFilterSelection() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ClearBUFilterSelection(data, event) {
            try {
                var selectedSubOrgLevelID = event.currentTarget.id.substr(event.currentTarget.id.indexOf("_") + 1);
                document.getElementById('DynamicBUOptedFilters_' + selectedSubOrgLevelID).innerHTML = "";
                $('.fa-check.' + selectedSubOrgLevelID).css({ 'display': 'none' });
                if (AMLViewModel.SelectedCheckedBUList().length > 0) {
                    AMLViewModel.SelectedCheckedBUList.remove(function (item) { return item.SubLevelId == selectedSubOrgLevelID })
                }

                //Logic to re-set the BU list
                AMLViewModel.BusinessUnitListForFilters([]);
                if (AMLViewModel.SelectedCheckedBUList().length > 0) {
                    var mappedBuList = $.map(AMLViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        for (var m = 0; m < AMLViewModel.SelectedCheckedBUList().length; m++) {
                            if (result.BusinessUnitId() == AMLViewModel.SelectedCheckedBUList()[m].SubLevelId)
                                return new BusinessUnitModelDUP(result);
                        }
                    });
                    AMLViewModel.BusinessUnitListForFilters(mappedBuList);

                }
                else {
                    AMLViewModel.BusinessUnitListForFilters([]);
                    var mappedBuList = $.map(AMLViewModel.BusinessUnitListForFiltersDUP(), function (result) {
                        return new BusinessUnitModelDUP(result);
                    });
                    AMLViewModel.BusinessUnitListForFilters(mappedBuList);

                    $('#OrgFilterError').hide();
                }
                //Set count of BU's selected
                if (AMLViewModel.BusinessUnitListForFilters().length > 0) {
                    AMLViewModel.DistinctFileredBUs = ko.dependentObservable(function () {
                        var seen = [];
                        return AMLViewModel.BusinessUnitListForFilters().filter(function (n) {
                            return seen.indexOf(n.BusinessUnitId()) == -1 && seen.push(n.BusinessUnitId());
                        });
                    });
                    AMLViewModel.BusinessUnitListForFilters(AMLViewModel.DistinctFileredBUs());
                }

                AMLViewModel.NumberOfBUsSelectedRA(AMLViewModel.BusinessUnitListForFilters().length);
                //GetAllControlsData();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearBUFilterSelection() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ApplyBuFitlers(data, event) {
            try {
                AMLViewModel.BUFiltersApplied(true);
                $('#ControlsAreaGrid').hide();
                $('#ControlsOverallGrid').hide();
                GetAllControlsData();
                closeSideNav();
                AMLViewModel.NumberOfBUsSelectedRA(AMLViewModel.BusinessUnitListForFilters().length);
                $('.badge').css({ 'display': 'inline-block' });
                $("#f-filter").css("display", "");
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ApplyBuFitlers() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ClearAllBuFitlers(data, event) {
            try {
                AMLViewModel.BUFiltersApplied(false);
                for (var i = 0; i < AMLViewModel.OrgLvlDrpDwnList().length; i++) {
                    for (var g = 0; g < AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList().length; g++) {
                        $("#sublevel" + AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).prop("checked", false);
                        $('.fa-check.' + AMLViewModel.OrgLvlDrpDwnList()[i].BusinessLevelValueList()[g].BlvalueId()).css({ 'display': 'none' });
                    }
                }
                for (var g = 0; g < AMLViewModel.BusinessUnitListForFiltersDUP().length; g++) {
                    $("#sublevel" + AMLViewModel.BusinessUnitListForFiltersDUP()[g].BusinessUnitId()).prop("checked", false);
                    $('.fa-check.' + AMLViewModel.BusinessUnitListForFiltersDUP()[g].BusinessUnitId()).css({ 'display': 'none' });
                }

                AMLViewModel.BusinessUnitListForFilters([]);
                $('#ControlsAreaGrid').hide();
                $('#ControlsOverallGrid').hide();
                GetAllControlsData();
                AMLViewModel.SelectedCheckedBUList([]);
                AMLViewModel.SelectedCheckedList([]);
                closeSideNav();
                AMLViewModel.NumberOfBUsSelectedRA(0);
                $('.badge').css({ 'display': 'none' });
                document.getElementById('DynamicOrgOptedFilters').innerHTML = "";
                $('#DynamicOrgOptedFilters').css({ 'display': 'none' });
                $('#f-filter').css('display', 'none');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearAllBuFitlers() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Grid Methods

        function RestructureControls() {
            try {
                if (AMLViewModel.AreaType() === 'A') {
                    $('#tblRAControl tbody').scroll(function (e) { //detect a scroll event on the tbody
                        $('#tblRAControl thead').css("left", -$("#tblRAControl tbody").scrollLeft()); //fix the thead relative to the body scrolling
                        $('#tblRAControl thead th:nth-child(1)').css("left", $("#tblRAControl tbody").scrollLeft()); //fix the first cell of the header
                        $('#tblRAControl tbody td:nth-child(1)').css("left", $("#tblRAControl tbody").scrollLeft()); //fix the first column of tdbody
                    });
                }
                else if (AMLViewModel.AreaType() === 'O') {
                    $('#tblRAControlOverall tbody').scroll(function (e) { //detect a scroll event on the tbody
                        $('#tblRAControlOverall thead').css("left", -$("#tblRAControlOverall tbody").scrollLeft()); //fix the thead relative to the body scrolling
                        $('#tblRAControlOverall thead th:nth-child(1)').css("left", $("#tblRAControlOverall tbody").scrollLeft()); //fix the first cell of the header
                        $('#tblRAControlOverall tbody td:nth-child(1)').css("left", $("#tblRAControlOverall tbody").scrollLeft()); //fix the first column of tdbody
                    });
                }

                if (AMLViewModel.Query() != "") {
                    SearchResult();
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RestructureControls() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function NavigationMenuHideShow(data) {
            try {
                if (data == "Hide") {
                    // Hides Area NavigationMenu
                    $('#HideNavMenuCntrl').hide();
                    $('#ShowNavMenuCntrl').show();
                    $('#FilterAreaAccordionCntrl').hide();
                    $("#tabContent").removeClass("col-lg-9").addClass("col-lg-12");

                }
                else {
                    // Shows Area NavigationMenu
                    $('#HideNavMenuCntrl').show();
                    $('#ShowNavMenuCntrl').hide();
                    $('#FilterAreaAccordionCntrl').show();
                    $("#tabContent").removeClass("col-lg-12").addClass("col-lg-9");

                }
                RestructureControls();
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in NavigationMenuHideShow() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region TreeView Methods

        function CollapseAllTreeView() {
            if ($('#spanExpandAll').text() == ((!AMLViewModel.LocaleCheckFlag() || AMLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : AMLViewModel.ObjGeneralSettings.LocalizedTextList()[AMLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name())) {
                $('#jsTreeAreaLevelCntrlRA').treeview('expandAll', { silent: true });
                $("#spanExpandAll").text((!AMLViewModel.LocaleCheckFlag() || AMLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : AMLViewModel.ObjGeneralSettings.LocalizedTextList()[AMLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
                $("#arrowSpan").addClass("fa-caret-down").removeClass("fa-caret-right");
            }
            else {
                $('#jsTreeAreaLevelCntrlRA').treeview('collapseAll', { silent: true });
                $("#spanExpandAll").text((!AMLViewModel.LocaleCheckFlag() || AMLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : AMLViewModel.ObjGeneralSettings.LocalizedTextList()[AMLViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name());
                $("#arrowSpan").addClass("fa-caret-right").removeClass("fa-caret-down");
            }
        }

        function ExpandAllTreeView() {
            $('#jsTreeAreaLevelCntrlRA').treeview('expandAll', { silent: true });
        }

        function SearchTreeView() {
            $('#jsTreeAreaLevelCntrlRA').treeview('search', ['Parent', {
                ignoreCase: true,
                exactMatch: false,
                revealResults: true,
            }]);
        }

        function InitiateLevelTree() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                getJsTreeAreaLevel = {
                    url: "/api/Configuration/GetEALData",
                    type: "GET",
                    data: { RiskAreType: AMLViewModel.SurveyTypeClicked(), SurveyCategoryID: AMLViewModel.SelectedSurveyComponentId().toString(), AssessmentTypes: AMLViewModel.AssessmentTypeId().toString(), ScreenType: 'RA' },
                    headers: headers
                };
                $.ajax(getJsTreeAreaLevel)
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in InitiateLevelTree() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                if (jsonResult.Incident_Description == null) {
                    //implement js tree logic here
                    AMLViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);
                    var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                        return new jsTreeModel(result);
                    });

                    $('#jsTreeAreaLevelCntrlRA').treeview({
                        data: MappedJsTreeList,
                        onNodeSelected: nodeClickEvent
                    });

                    var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                    AMLViewModel.hasChildNodes(hasChildNodes);

                    //for initial load expand for treeview
                    $("#jsTreeAreaLevelCntrlRA ul:first li:first").trigger("click");
                }
                else {
                    if (jsonResult == null || jsonResult == undefined) {
                        logger.logError('An error occurred. Please contact your Application Administrator.' + " - " + msg, 'Error', system.getModuleId(AMLViewModel), true);
                    }
                    else {
                        var msg = 'An error occurred. Please contact your Application Administrator.';
                        logger.logError(jsonResult.Incident_Description + " - " + msg, 'Error', system.getModuleId(AMLViewModel), true);
                    }
                }
            }
            function nodeClickEvent(event, node) {
                AMLViewModel.AreaType(node.RA_Type());
                $('#jsTreeAreaLevelCntrlRA').treeview('selectNode', [node.nodeId, { silent: true }]);
                $('#ControlsAreaGrid').hide();
                $('#ControlsOverallGrid').hide();

                AMLViewModel.ClickedControlAreaId(parseInt(node.id));
                AMLViewModel.ClickedControlAreaName($('<div/>').html(node.text).text());
                GetAllControlsData();
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in nodeClickEvent() method in AMLControlRiskAssessment.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in nodeClickEvent() method in AMLControlRiskAssessment.js';
                    logger.logMessage(msg);
                }
            };
        }

        //#endregion

        //#region Search

        function ClearResult() {
            try {
                if (event.which == 13) {
                    if (AMLViewModel.Query() != "") {
                        SearchResult();
                    }
                }
                if (AMLViewModel.Query() != "") {
                    $(".reset-search").show();
                    return false;
                }
                else {
                    $(".reset-search").hide();
                    ResetSearch();
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearResult() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ResetSearch() {
            try {
                AMLViewModel.Query('');
                if (AMLViewModel.SubFactorGridDataList() != undefined) {
                    for (var i = 0; i < AMLViewModel.SubFactorGridDataList().length; i++) {
                        $(".raTaxo_" + AMLViewModel.SubFactorGridDataList()[i].SubFactorId()).show();
                    }
                }
                $(".reset-search").hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetSearch() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SearchResult() {
            try {
                if (AMLViewModel.SubFactorGridDataList() != undefined && AMLViewModel.SubFactorGridDataList().length > 0) {
                    var searchedList = '';
                    var q = AMLViewModel.Query();

                    searchedList = ko.utils.arrayFilter(AMLViewModel.SubFactorGridDataList(), function (item) {
                        if (q != "") {
                            if (item.SubFactorName().toLowerCase().indexOf(q.toLowerCase()) >= 0) {
                                return item.SubFactorName().toLowerCase().indexOf(q.toLowerCase()) >= 0;
                            }
                        }
                    });

                    for (var i = 0; i < AMLViewModel.SubFactorGridDataList().length; i++) {
                        $(".raTaxo_" + AMLViewModel.SubFactorGridDataList()[i].SubFactorId()).hide();
                    }

                    if (AMLViewModel.Query() != undefined && AMLViewModel.Query() == "") {
                        //for empty keyboard input
                        for (var i = 0; i < AMLViewModel.SubFactorGridDataList().length; i++) {
                            $(".raTaxo_" + AMLViewModel.SubFactorGridDataList()[i].SubFactorId()).show();
                        }
                    }
                    if (searchedList != undefined) {
                        for (var j = 0; j < searchedList.length; j++) {
                            for (var i = 0; i < AMLViewModel.SubFactorGridDataList().length; i++) {
                                if (AMLViewModel.SubFactorGridDataList()[i].SubFactorId() == searchedList[j].SubFactorId()) {

                                    $(".raTaxo_" + AMLViewModel.SubFactorGridDataList()[i].SubFactorId()).show();
                                }
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchResult() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Model Definitions

        function jsTreeModel(item) {
            var self = this;
            self.id = item.AreaLevelId.toString();
            self.text = item.AreaLevelName;
            if (AMLViewModel.AreaLeveljstree()[self.id].length > 0 && item.DeadNode == 0) {
                self.nodes = $.map(AMLViewModel.AreaLeveljstree()[self.id], function (result) {
                    return new jsTreeModel(result);
                });
            }
            self.state = { expanded: false };
            self.dead_node = item.DeadNode;
            self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
            self.RA_Type = ko.observable(item.RA_Type);
        }

        function CalculatedBottomLevelModel(item) {
            try {
                var self = this;
                self.BuId = ko.observable($('<div/>').html(item.BuId).text());
                self.BuName = ko.observable($('<div/>').html(item.BuName).text());
                self.CalculatedRiskLevel = ko.observable($('<div/>').html(item.CalculatedRiskLevel).text());
                self.CalculatedRiskLevelCss = ko.observable($('<div/>').html(item.CalculatedRiskLevelCss).text());
                self.FinalRiskLevel = ko.observable($('<div/>').html(item.FinalRiskLevel).text());
                self.FinalRiskLevelCss = ko.observable($('<div/>').html(item.FinalRiskLevelCss).text());
                self.ComplianceRIskLevel = ko.observable($('<div/>').html(item.ComplianceRIskLevel).text());
                self.ComplianceRIskLevelCss = ko.observable($('<div/>').html(item.ComplianceRIskLevelCss).text());
            }
            catch (e) {

                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function BusinessLevelsModel(item) {
            try {
                var self = this;
                self.Bulevel = ko.observable($('<div/>').html(item.Bulevel).text());
                self.BlName = ko.observable($('<div/>').html(item.BlName).text());
                self.BlId = ko.observable(item.BlId)
                var MappedBuLevelValueList = $.map(item.BuLevelValueList, function (result) {
                    return new BuLevelValueListModel(result);
                });
                self.BusinessLevelValueList = ko.observableArray(MappedBuLevelValueList);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessLevelsModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SurveyCategoryModel(item) {
            try {
                var self = this;
                self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
                self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
                self.SurveyCategoryShortName = ko.observable(item.SurveyCategoryShortName);
                self.SurveyType = ko.observable(item.SurveyType);
                self.Applicability = ko.observable(item.Applicability);
                self.SurveyGroupId = ko.observable(item.SurveyGroupId);
                self.SurveyGroupFullName = ko.observable(item.SurveyGroupFullName);
                self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
                self.IsEditable = ko.observable(item.IsEditable);
                self.AssessmentTypeId = ko.observable(item.AssessmentTypeId);
                self.AssessmentTypeName = ko.observable(item.AssessmentTypeName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SubFactorDataModel(item) {
            try {
                var self = this;
                self.ResponseId = ko.observable(item.ResponseId);
                self.Responsevalue = ko.observable($('<div/>').html(item.Responsevalue).text());
                self.BuId = ko.observable(item.BuId);
                self.HeatMapCss = ko.observable(item.HeatMapCss);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubFactorDataModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function SubFactorDataListModel(item) {
            try {
                var self = this;
                self.SubFactorId = ko.observable($('<div/>').html(item.SubFactorId).text());
                self.SubFactorName = ko.observable($('<div/>').html(item.SubFactorName.replace('&amp;', '&')).text());
                self.RowColorQues = ko.observable($('<div/>').html(item.RowColor).text());
                var MappedObject = $.map(item.BusinessUnitCountList, function (result) {
                    return new BUCountListModel(result);
                });
                self.BusinessUnitCountList = MappedObject;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubFactorDataListModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function BUCountListModel(item) {
            try {
                var self = this;
                var MappedObject = $.map(item.ResponseList, function (result) {
                    return new RiskLevelModel(result);
                });
                self.ResponseList = MappedObject;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BUCountListModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function RiskLevelModel(item) {
            try {
                var self = this;
                if (item.RiskLevelText != undefined && item.RiskLevelText != '')
                    self.RiskLevelText = ko.observable($('<div/>').html(item.RiskLevelText).text());
                else
                    self.RiskLevelText = "";

                self.Response_BUId = ko.observable($('<div/>').html(item.Response_BUId).text());
                self.SubFactorId = ko.observable($('<div/>').html(item.SubFactorId).text());
                self.RowColor = ko.observable($('<div/>').html(item.RowColor).text());
                self.ResponseId = ko.observable($('<div/>').html(item.ResponseId).text());
                self.Responsevalue = ko.observable($('<div/>').html(item.Responsevalue).text());
                self.ResponsevalueTitle = ko.observable($('<div/>').html(item.Responsevalue).text());
                if (item.Responsevalue != undefined && item.Responsevalue.length > 16) {
                    var value = item.Responsevalue.substring(0, 16) + '...';
                    self.Responsevalue = ko.observable($('<div/>').html(value).text());
                }

                //logic is reverse to bind html in opp 
                if (item.Applicability == 0)
                    self.Applicability = ko.observable(true);
                else
                    self.Applicability = ko.observable(false);
                self.HeatMapCss = ko.observable($('<div/>').html(item.HeatMapCss).text());
                self.ResponsevalueTitle = self.ResponsevalueTitle().replace(/&gt;/g, '>').replace(/&lt;/g, '<');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RiskLevelModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function OverrideCommentModel(item) {
            try {
                var self = this;
                self.CommentId = ko.observable(item.CommentId);
                self.CommentText = ko.observable($('<div/>').html(item.CommentText).text());
                self.UploadedBy = ko.observable($('<div/>').html(item.UploadedBy).text());
                self.UploadRole = ko.observable($('<div/>').html(item.UploadRole).text());
                self.UploadedDate = ko.observable($('<div/>').html(item.UploadedDate).text());
                self.FullName = ko.computed(function () {
                    return item.UploadedBy + " (" + $('<div/>').html(item.UploadRole).text() + ")";
                });
            }
            catch (e) {
                var msg = 'exception' + e + 'source: OverrideCommentModel() in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function WTBusinessLevelsModel(item) {
            try {
                var self = this;
                self.BUId = ko.observable(item.BusinessUnitId);
                self.BUName = ko.observable(item.BusinessUnitName);
                if (item.BusinessUnitName.length > 18) {
                    self.BUShortName = ko.observable((item.BusinessUnitName).substring(0, 15) + '...');
                }
                else
                    self.BUShortName = ko.observable(item.BusinessUnitName);
                if (item.BUWeightings !== undefined && item.BUWeightings !== null) {
                    var MappedWeights = $.map(item.BUWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.BUWeightings = MappedWeights;
                }
                self.total = ko.computed(function () {
                    var total = 0;
                    for (var p = 0; p < self.BUWeightings.length; ++p) {
                        total += Number(Number(self.BUWeightings[p].WeightingValue()).toFixed(AMLViewModel.decimalLimit()));
                    }
                    return total.toFixed(AMLViewModel.decimalLimit());
                });
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: WTBusinessLevelsModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function RiskAreaModel(item) {
            try {
                var self = this;
                if (item.QuestionType == null) {
                    self.QuestionType = '';
                }
                else
                    self.QuestionType = item.QuestionType;
                self.AreaId = ko.observable(item.AreaId);
                self.AreaName = ko.observable(item.AreaName);
                if (item.AreaName.length > 43) {
                    self.AreaShortName = ko.observable((item.AreaName).substring(0, 40) + '...');
                }
                else
                    self.AreaShortName = ko.observable(item.AreaName);
                if (item.AreaWeightings !== undefined && item.AreaWeightings !== null) {
                    var MappedWeights = $.map(item.AreaWeightings, (result) => {
                        return new WeightingsModel(result);
                    });
                    self.AreaWeightings = MappedWeights;
                }
                self.selectedBuWeight = ko.observable(0);
                self.selectedBuWeight.subscribe(function (newVal) {
                    if ($.isNumeric(newVal) && newVal >= 0.00000 && newVal <= 100.00000) {
                        var total = 0;
                        for (var i = 0; i < AMLViewModel.AreasOrQuestions().length; i++) {
                            total += Number(Number(AMLViewModel.AreasOrQuestions()[i].selectedBuWeight()).toFixed(AMLViewModel.decimalLimit()));
                        }
                        //total -= 0.000005;
                        AMLViewModel.EditableBusinessunitTotal(total.toFixed(AMLViewModel.decimalLimit()));
                    }
                    else if ($.isNumeric(newVal) && (newVal < 0.00000 || newVal > 100.00000)) {
                        this.selectedBuWeight(0);
                        logger.logError('Value should be in range of (0-100).', 'Error', system.getModuleId(AMLViewModel), true);
                    }
                    else {
                        this.selectedBuWeight(0);
                        logger.logError('Non-numeric values are not allowed.', 'Error', system.getModuleId(AMLViewModel), true);
                    }
                }, this);

                self.Applicability = ko.observable(0);
                self.Applicability.subscribe(function (newVal) {
                    this.Applicability(newVal);
                }, this);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function WeightingsModel(item) {
            try {
                var self = this;
                self.BuId = ko.observable(item.BuId);
                self.RiskAreaId = ko.observable(item.RiskAreaId);
                self.WeightingValue = ko.observable(item.WeightingValue);
                self.Applicability = ko.observable(item.Applicability);
            }
            catch (e) {
                let msg = 'Exception: ' + e + ' | Source: WeightingsModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function BusinessUnitModelFilter(item) {
            try {
                var self = this;
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BuId).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BuName).text());
                self.AssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
                self.BuName = ko.observable($('<div/>').html(item.BuName).text());
                self.SubLevelId = ko.observable(item.SubLevelId);
                self.isChecked = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnitModelFilter() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function BusinessUnitModelDUP(item) {
            try {
                var self = this;
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BuId = ko.observable($('<div/>').html(item.BusinessUnitId()).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.BuName = ko.observable($('<div/>').html(item.BusinessUnitName()).text());
                self.AssessmentDate = ko.observable($('<div/>').html(item.AssessmentDate()).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus()).text());
                self.SubLevelId = ko.observable(item.SubLevelId());
                self.isChecked = ko.observable(false);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnitModelDUP() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function BusinessUnitModel(item) {
            try {
                var self = this;
                self.BusinessUnitId = ko.observable($('<div/>').html(item.BuId).text());
                self.BusinessUnitName = ko.observable($('<div/>').html(item.BuName).text());
                self.AssessmentDate = ko.observable($('<div/>').html(item.BuAssessmentDate).text());
                self.BuStatus = ko.observable($('<div/>').html(item.BuStatus).text());
                self.ToClear = ko.observable(true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnitModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ResponselevelModel(item) {
            try {
                var self = this;
                self.Id = ko.observable($('<div/>').html(item.Id).text());
                self.Response = ko.observable($('<div/>').html(item.Response).text());
                self.Description = ko.observable($('<div/>').html(item.Description).text());
                self.Response_Ref_Id = ko.observable(item.Response_Ref_Id);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponselevelModel() method in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        function ResponseCommentsModel(item) {
            try {
                var self = this;
                self.CommentId = ko.observable(item.CommentId);
                self.CommentText = ko.observable($('<div/>').html(item.CommentText).text());
                self.UploadedBy = ko.observable($('<div/>').html(item.UploadedBy).text());
                self.UploadedDate = ko.observable($('<div/>').html(item.UploadedDate).text());
            }
            catch (e) {
                var msg = 'exception' + e + 'source: ResponseCommentsModel() in AMLControlRiskAssessment.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

    });
